module.exports = __webpack_public_path__ + "static/media/1009803.2ae8e33f.jpg";